import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/actions';
import classes from './CountryPicker.css';

const CountryPicker = (props) => {

  const [countries, setCountries] = useState([]);
  
  useEffect(() => {
  	     props.onGetMapAsync();
  	     if (props.countries.length > 0) {
  	      //	console.log('props.countries',props.countries.slice(0,1)[0]);
  	      	setCountries(props.countries);
  	      }

  }, [props.loadingMap])

  return (
     <div className={classes.CountryPicker}>
     	   <select id="countries" name="countries" aria-label="countries" onChange={props.handleSelectChange} value={props.selected}>
             { countries.map((c,i) => (
        	 <option value={c.name} key={i}>{c.country}</option>
        	 )) }
         </select>
     </div>
	)
}

const mapStateToProps = state => {
  return {
  	countries: state.mapReducer.mapData.countries,
  	loadingMap: state.mapReducer.mapData.loading
  }
}

const mapDispatchToProps = dispatch => {
	return {
		onGetMapAsync: () => dispatch(actions.getMapAsync())
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(CountryPicker);


// WEBPACK FOOTER //
// ./src/containers/CountryPicker/CountryPicker.js